import React, { Component } from 'react'
import View from './view'
import Success from './success'
import StrategyUtils from '../utils/strategyUtils'
import { getUser } from '../utils/queryParams'

class PasswordReset extends Component {
  constructor(props) {
    super(props)

    this.strategies = StrategyUtils.parseStrategyParams(props.strategies)
    this.userType = StrategyUtils.strategiesToUserType(this.strategies)
    this.prefilledUser = getUser()

    this.state = {
      user: this.prefilledUser,
      errors: {},
      loading: false,
      success: false,
    }
  }

  handleChange = (name, value) => {
    this.setState({ [name]: value })
  }

  handleSubmit = (event) => {
    event.preventDefault()
    this.setState({ errors: {} })
    this.sendPasswordReset(this.state.user.toLowerCase(), this.strategies)
  }

  sendPasswordReset = (user, strategies) => {
    this.setState({ loading: true })
    return fetch(`${process.env.REACT_APP_API_HOST}/api/v1/send-password-reset`,
      {
        method: 'POST',
        headers: new Headers({
          'content-type': 'application/json',
        }),
        body: JSON.stringify({ user: user, strategies: strategies })
      })
      .then(resp => {
        if (!resp.ok) return Promise.reject(resp)
        return this.setState({ success: true })
      })
      .catch(() => {
        this.setState({ errors: { summary: ['We ran into an issue while resetting your password, please try again or contact support'] } })
      }).then(() => this.setState({ loading: false }))
  }

  render() {
    return(
      this.state.success ?
        <Success /> :
        <View
          prefilledUser={this.prefilledUser}
          loading={this.state.loading}
          errors={this.state.errors}
          handleChange={this.handleChange}
          handleSubmit={this.handleSubmit}
          userType={this.userType}
        />
    )
  }
}

export default PasswordReset



// WEBPACK FOOTER //
// ./src/password-reset/index.jsx